import { render, staticRenderFns } from "./ContactSelectorField.vue?vue&type=template&id=07178220&scoped=true"
import script from "./ContactSelectorField.vue?vue&type=script&lang=ts"
export * from "./ContactSelectorField.vue?vue&type=script&lang=ts"
import style0 from "./ContactSelectorField.vue?vue&type=style&index=0&id=07178220&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07178220",
  null
  
)

export default component.exports